<template>
  <a @click="$refs.modalTest.openModal()">
    <ImageMagnifier
      :alt="alt"
      :src="src"
      :zoom-src="zoomsrc"
      maskBgColor="#434140"
      width="100%"
      height="auto"
      mask-height="70"
      mask-width="70"
      :scale="5"
      :orientation="zoomorientation"
    />
  </a>
  <Modal ref="modalTest" :isModalOpen="isModalOpen" @closeModal="closeModal">
    <img :src="currentSrc" alt="" />
  </Modal>
</template>

<script>
import Modal from "../../components/Modal/Modal.vue";
import ImageMagnifier from "../../components/ImageMagnifier/ImageMagnifier.vue";

export default {
  name: "app",
  components: {
    Modal,
    ImageMagnifier
  },
  data() {
    return {
      isModalOpen: false,
      currentSrc: null,
      alt: this.$options._parentVnode.data.props.alt,
      src: this.$options._parentVnode.data.props.imagesrc,
      zoomsrc: this.$options._parentVnode.data.props.imagezoom,
      zoomorientation: this.$options._parentVnode.data.props.zoomorientation
    };
  },
  methods: {
    openModal(image) {
      this.currentSrc = image;
      setTimeout(() => {
        this.isModalOpen = true;
      }, 600);
    },
    closeModal() {
      this.isModalOpen = false;
      this.currentSrc = null;
    }
  }
};
</script>
